<template>
  <header :class="$style.header">
    <div :class="$style.content">
      <a
        href="https://feis.bstu.by/feis@bstu.by"
        target="__blank"
        :class="$style.logo"
      >
        <img src="/images/logo.png" alt="" />
      </a>
      <div :class="$style.contacts">
        <a href="tel:80162321796">8 (0162) 32-17-96</a>
        <a href="tel:80162321713">8 (0162) 32-17-13</a>
      </div>
      <a
        href="https://feis.bstu.by/feis@bstu.by"
        target="__blank"
        :class="$style.textLogo"
      >
        <img src="/images/logo2.png" alt="" />
      </a>
    </div>
  </header>
</template>

<style lang="scss" module>
.header {
  padding: 1rem 2rem;
  background-color: $white;
  margin: 0 0 2rem 0;
}
.content {
  max-width: 78.75rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo {
    cursor: pointer;
    max-width: 12rem;
    max-height: 2.875rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .textLogo {
    cursor: pointer;
    max-width: 12rem;
    max-height: 3.5rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    @include custom(860) {
      display: none;
    }
  }
  .contacts {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    @include custom(400) {
      display: block;
    }
    a {
      display: block;
      font-weight: 600;
      transition: all 0.3s ease-in-out;
      &:hover {
        color: $red;
      }
      @include custom(475) {
        font-size: 0.8rem;
      }
    }
  }
}
</style>
